import * as actionTypes from "./actionTypes";
import {
  getMyApprovedConsentsApi,
  previewMyConsentAPI,
} from "@icarius-connection/api";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString, getErrorStringFromServerError } from "@icarius-localization/strings";
import { previewFromBlob } from "@icarius-utils/download";
import { getFileExtension, getFileName } from "@icarius-utils/fileUpload";

const errorHandler = (e, dispatch) => {
  let errorString = "";
  switch (e.response?.data?.status) {
    case "INVALID_DATA":
      errorString = getLocalizedString("validationError");
      break;
    default:
      errorString = getErrorStringFromServerError(e);
      break;
  }
  dispatch(openSnackbarAction({ msg: errorString, severity: "error" }));
}

export const getMyApprovedConsentsAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET });
  try {
    let response = await getMyApprovedConsentsApi();
    let data = response.data && response.data.data;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_FULFILLED,
      payload: { data },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const previewMyConsentAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: actionTypes.PREVIEW_MY_CONSENT });
  try {
    let response = await previewMyConsentAPI(dataToSend);
    if (response.status !== 200) {
      dispatch({ type: actionTypes.PREVIEW_MY_CONSENT_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    let title = response.headers["x-content-namefile"];
    previewFromBlob(response.data, getFileExtension(title), getFileName(title));

    dispatch({ type: actionTypes.PREVIEW_MY_CONSENT_FULFILLED });

    return response;
  } catch (e) {
    dispatch({ type: actionTypes.PREVIEW_MY_CONSENT_REJECTED });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
  }
};
